import Service from "./Service";
import { LogInfoEntity } from "../model/Logs";
import { PageList } from "@/model/system";
class logsService extends Service {
  getLogInfo(data: LogInfoEntity) {
    return this.post<LogInfoEntity>(`/LogInfo/List`, data);
  }
  getLogs(data: LogInfoEntity) {
    return this.post<PageList<LogInfoEntity>>(`/LogInfo/Logs`, data);
  }
  add(data: LogInfoEntity) {
    // return $http.post(this.getUrl(`/LogInfo/Added`), data);
    return this.post<string>(`/LogInfo/Added`, data);
  }
}
export default new logsService("logs");
